
export default function* sampleSage(){
    try{

    }catch{
        yield;
    }
}